const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID?.trim();
const isProduction = window.location.hostname === "paretti.net"
  || window.location.hostname === "www.paretti.net";

const afterCriticalRender = (callback) => {
  let scheduled = false;
  let fallback;
  const run = () => {
    if (scheduled) return;
    scheduled = true;
    clearTimeout(fallback);
    window.removeEventListener("heroready", queue);
    const queueIdle = () => {
      if (window.requestIdleCallback) window.requestIdleCallback(callback, { timeout: 1800 });
      else setTimeout(callback, 250);
    };
    if (document.readyState === "complete") queueIdle();
    else window.addEventListener("load", queueIdle, { once: true });
  };
  const queue = () => run();

  if (document.getElementById("fabric-canvas")
    && !document.documentElement.classList.contains("is-hero-revealed")
    && !document.body.matches(".no-webgl, .is-hero-static")) {
    window.addEventListener("heroready", queue, { once: true });
    fallback = setTimeout(run, 5000);
  } else {
    run();
  }
};

// Keep the tiny first-party tracker available for short visits. It schedules
// its own beacon during idle time and does not load a third-party runtime.
if (isProduction && !window.__parettiInsights) {
  const insights = document.createElement("script");
  insights.src = "/insights/tracker.js?v=1";
  insights.async = true;
  document.head.append(insights);
}

if (isProduction && /^G-[A-Z0-9]+$/i.test(measurementId || "")) {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", measurementId, {
    allow_ad_personalization_signals: false,
    allow_google_signals: false,
    cookie_flags: "SameSite=None;Secure",
    transport_type: "beacon",
  });

  const loadScript = () => {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    document.head.append(script);
  };
  afterCriticalRender(loadScript);
}
